// extracted by mini-css-extract-plugin
export var ignore = "_6w-1";
export var mapping = "_6w-0";
export var range = "_6w-4";
export var savings = "_6w-3";
export var settings = "_6w-2";